import { OrderType } from "../enums/OrderType";

export class BaseFilterInput {
    shouldPaginate: boolean = true;
    pageSize: number = 10;
    currentPage: number = 1;
    orderBy?: string | null | undefined;
    orderType: OrderType = OrderType.Ascending;
}